
























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from "@/components/User";
import { L } from "@/common/filters";
import { IMapLayer, IMapLayerSource } from "@/components/map/types";
import { SDS } from "@/components/SDS";

@Component({
  watch: {
    data(value) {
      this.setData();
    }
  }
})
export default class StationSummary extends Vue {
  @Prop({
    default: null
  }) data: Object; //SDS

  sds:SDS = null;
  today: Date = new Date();
  Agritronics:IMapLayerSource = null;
  AgritronicsPhase2:IMapLayerSource = null;
  WaterStation:IMapLayerSource = null;
  AgritronicsIsVisible: boolean = false;
  AgritronicsPhase2IsVisible: boolean = false;
  WaterStationIsVisible: boolean = false;

  setData() {
    if (!this.data) return;
    if (this.data && this.data['sds'] && this.data['sds'] instanceof SDS) {
      this.sds = this.data['sds'];
    } else {
      this.sds = null;
    }
    if (this.data['mapLayers']) {
      this.Agritronics = this.data['mapLayers'].Agritronics;
      this.AgritronicsPhase2 = this.data['mapLayers'].AgritronicsPhase2;
      this.WaterStation = this.data['mapLayers'].WaterStation;
      this.AgritronicsIsVisible = this.isStationVisible(this.Agritronics);
      this.AgritronicsPhase2IsVisible = this.isStationVisible(this.AgritronicsPhase2);
      this.WaterStationIsVisible = this.isStationVisible(this.WaterStation);
    }
  }

  created() {
    this.setData();
  }

  isStationVisible(ms:IMapLayerSource) : boolean {
    if (ms.nativeLayer) {
      return ms.nativeLayer.getVisible();
    } else if (ms.mapLayers) {
      return ms.mapLayers[0].visible;
    }
    return ms.visible;
  }

  justMakeItHover() {}

  toggleStationLayer(station:"Agritronics" | "AgritronicsPhase2" | "WaterStation") {
    let layer:IMapLayer;
    layer = station=='Agritronics' ? this.Agritronics :
            station=='AgritronicsPhase2' ? this.AgritronicsPhase2 : 
            this.WaterStation;
    layer.visible = layer.checked = !layer.checked;
    this[station + 'IsVisible'] = layer.visible;
    layer.mapSources.forEach((ms) => {
      ms.visible = layer.visible;
      if (ms.nativeLayer) {
        ms.nativeLayer.setVisible(ms.visible);
      }
    });
    /*if (ms.mapLayers) {
      ms.mapLayers.forEach((ml) => {
        ml.visible = !ml.visible;
        //ml.checked = ml.visible;
      });
      ms.visible = ms.mapLayers[0].visible;
    }
    if (ms.nativeLayer) {
      ms.nativeLayer.setVisible(ms.visible);
    }
    this[station + 'IsVisible'] = ms.visible;*/
    
    this.$emit('changeMe',{
      menu: {
        name: 'update_visible_layers'
      }
    });
  }

  closeMe() {
    this.$emit('closeRightToc');
  }
}
